<template>
  <div
    class="custom-wrapper"
    :class="$sidebar.showSidebar ? 'nav-bar-shown': 'nav-bar-hidden'"
  >
    <side-bar>
      <div
        v-for="navLink in availableLinks"
        :key="navLink.path"
      >
        <sidebar-link :link="navLink" />

        <div v-if="navLink.children">
          <sidebar-link
            v-for="childLink in navLink.children"
            :key="childLink.path"
            :link="childLink"
            :sub-item="true"
          />
        </div>

        <br>
      </div>
    </side-bar>


    <div class="main-panel">
      <top-navbar />

      <dashboard-content />
    </div>
  </div>
</template>
<script>
    import TopNavbar from "./TopNavbar.vue";
    import DashboardContent from "./Content.vue";

    import {defaultNavBarTree, navBarLinksByRoles} from "../../assets/navBarRoutes";
    import {getUserRole} from "../../assets/adminRoles";

    export default {
        components: {
            TopNavbar,
            DashboardContent
        },
        data() {
          const role = getUserRole();

          return {
            availableLinks: navBarLinksByRoles[role] || defaultNavBarTree
          };
        }
    };
</script>
<style lang="scss">
    .custom-wrapper.nav-bar-shown {
        .sidebar {
            transform: translateX(0);
        }
        .main-panel {
            width: calc(100% - 260px);
        }
    }
    .custom-wrapper.nav-bar-hidden {
        .sidebar {
            transform: translateX(-260px);
        }
        .main-panel {
            width: 100%;
        }
    }
</style>
